export const STORAGE_KEY = {
  USERNAME: '_u__',
  LOGIN_ID: 'l__',
  REMEMBER_ME: 'r__M',
  SAVE_PIN: 's_p',
  SET_HEADER: 'SET_HEADER',
  PIN: 'p_',
  SESSION_ID: 's_',
  LANGUAGE: 'l',
  T_ACCOUNT:'t_a',
  THEME: 't',
  MAIN_MENU: 'm_M',
  SUB_MENU: 's_M',
  TOKEN: '_k_t-',
  STATUS: 'ls_',
  FIRST_CRE: 'f_c',
  SECOND_CRE: 's_c',
  LAST_SEARCH_FROM_DATE: 'l_s_f_d',
  LAST_SEARCH_TO_DATE: 'l_s_t_d',
  SAVE_MATRIX_CARD: 's_mc',
  TRANS_SEARCH_END_DATE: 't_s_e_d',
  ALL_STOCK_INFO: 'allStockInfos',
  SELECTED_INSTRUMENT: 's_i',
  QUOTE: 'q_o_e',
  STOCK_SETTING: 's_o_s',
  WIN_VEST_ACCESS_TOKEN: '_w_v_t_',
  WIN_VEST_CSRF_TOKEN: 'w_v_s_c_r_f_t',
  USER: '_u_',
  WIN_VEST_SESSION: '_w_s__',
  WIN_VEST_SESSION_NAME: '_w_s_n__',
  WIN_VEST_UUID: '_w_i__',
  DEVICE_ID: 'd_i',
  TIME: 't_m__',
  TRADE_ACCOUNT:'t_d_a_c_',
  ACCESSIBILITY: '__a_cc_',
  MDS_ACCOUNT_TYPE: "m_a_t",
}

export const SESSION_STORAGE_KEY = [
  STORAGE_KEY.USER,
  STORAGE_KEY.LOGIN_ID,
  STORAGE_KEY.TOKEN,
  STORAGE_KEY.USERNAME,
  STORAGE_KEY.WIN_VEST_ACCESS_TOKEN,
  STORAGE_KEY.WIN_VEST_CSRF_TOKEN,
  STORAGE_KEY.WIN_VEST_SESSION,
  STORAGE_KEY.WIN_VEST_SESSION_NAME,
  STORAGE_KEY.T_ACCOUNT,
  STORAGE_KEY.TRADE_ACCOUNT
]
